import { MouseEventHandler } from "react";

import { Box, Heading, Stack, Text, useBreakpoint, Var } from "@seneca/senekit";

import { ChildrenType } from "seneca-common/features/parents/features/parent/service/hooks/types";

import SelectCard from "features/common/components/SelectCard";
import useGetSelectedChildName from "features/parents/features/monitoring-overview/hooks/useGetSelectedChildName";
import useChildSubscriptionInfo from "features/parents/hooks/useChildSubscriptionInfo";
import PlanTag from "features/parents/pages/settings/components/TransferSubscriptionModal/components/PlanTag";

type Props = {
  child: ChildrenType;
  selected?: boolean;
  onClick?: MouseEventHandler;
};

export default function SelectChildCard({ child, selected, onClick }: Props) {
  const { isMobileOnly } = useBreakpoint();
  const { givenName, email, userId: childId } = child;
  const headingText = useGetSelectedChildName({
    selectedChild: child,
    shouldDisplayFullName: true
  });

  const { tierName, canSubscriptionBeTransferredTo } =
    useChildSubscriptionInfo(childId);

  const showSubtitleText = !!givenName;

  const disabled = !canSubscriptionBeTransferredTo;

  const textSize = isMobileOnly ? "small" : "medium";
  const textTone = selected ? "primary" : "neutral";

  return (
    <SelectCard disabled={disabled} selected={selected} onClick={onClick}>
      <Box display="flex" justifyContent="space-between" flexWrap="nowrap">
        <Box width="65%" paddingRight="small">
          <Heading tone={textTone} level="5">
            <Box overflow="hidden" textOverflow="ellipsis">
              {headingText}
            </Box>
          </Heading>
        </Box>
        <PlanTag plan={tierName} />
      </Box>
      <Stack space="large">
        {showSubtitleText && (
          <Text tone={textTone} size={textSize} truncate dataNoTranslate>
            {email}
          </Text>
        )}
        {disabled && (
          <Text size={textSize}>
            You can't transfer to{" "}
            {!!givenName ? <Var>{givenName}</Var> : "your child"} because their
            account already has a personal subscription
          </Text>
        )}
      </Stack>
    </SelectCard>
  );
}
